import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'aa-popin-subtitle',
    templateUrl: './popin-subtitle.component.html',
    styleUrls: [
        './popin-subtitle.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PopinSubtitleComponent implements OnInit
{
    constructor() { }

    ngOnInit ()
    {
    }
}
